var _effectorFileName = "/builds/gmini/front-common/src/keycloakAuth/auth/authData.ts";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { createEvent, restore } from 'effector';
export var saveAuthData = createEvent({
  name: "saveAuthData",
  sid: "nahv2e"
});
export var resetAuthData = createEvent({
  name: "resetAuthData",
  sid: "-oeqron"
});
export var setKeycloak = createEvent({
  name: "setKeycloak",
  sid: "xzsz70"
});
export var tokenData$ = restore(saveAuthData, null, {
  name: "tokenData$",
  sid: "1v7igp"
}).reset(resetAuthData);
export var keycloak$ = restore(setKeycloak, null, {
  name: "keycloak$",
  sid: "ug8jcb"
});
export function refreshTokenFunc() {
  return _refreshTokenFunc.apply(this, arguments);
}

function _refreshTokenFunc() {
  _refreshTokenFunc = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var keycloak, tokenUpdated;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            keycloak = keycloak$.getState();

            if (keycloak) {
              _context.next = 3;
              break;
            }

            throw new Error('Keycloak instance is null');

          case 3:
            _context.next = 5;
            return keycloak.updateToken(5);

          case 5:
            tokenUpdated = _context.sent;
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              return !keycloak.token || !keycloak.authenticated || !tokenUpdated ? reject(new Error('Unauthorized')) : resolve({
                accessToken: keycloak.token
              });
            }));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _refreshTokenFunc.apply(this, arguments);
}